import { RootContainer } from '../../../core/root_container';
import { ItemDetailRrAction } from '../../actions/item_detail_rr_action';
import { ItemJsEnv } from '../../models/item_js_env';
import { RrBodyItemModal } from './item_detail_rr_body';

export class ItemDetailRrModalContainer extends RootContainer<ItemJsEnv> {
  constructor() {
    super();

    ItemDetailRrAction.UPDATE_EVENT.on((model: ItemJsEnv) => {
      // 同じ「かごに入れる」ボタンを押下するとmount設定が重複するためcomponentsを初期化
      this.components = [];
      this.mount(RrBodyItemModal, model.rrAreaProfileItemModal.placementName);
      this.update(model);

      const WindowCarousel = window._carousel;
      new WindowCarousel( // NOSONAR
        `#${model.rrAreaProfileItemModal.placementName}`
      );
    });
  }
}
